export default "__VITE_ASSET__Y35DBk27__"